export default "__VITE_ASSET__ZXWwIbsA__"